// 测试
export default {
  bucketName: 'test-ubq',
  cdnUrl: 'https://obs.test.ubanquan.cn',
  // 优版权obs cdn
  cdnMLMUrl: 'https://obs.testipbank.ubanquan.cn',
  // 漫联盟obs cdn
  cdnBWLUrl: 'https://obs.testbwl.ubanquan.cn',
  // obs博物联
  haiXinUrl: 'https://test.haixing.tianhecloud.com/#/oauth' // 海星钱包 测试地址

};